import { Component } from 'opus-angular-seed-core';

@Component({
    transclude: true,
    bindings: {
        error: '=',
        additionalClasses: '@'
    },
    template: `
        <div class="row {{ vm.additionalClasses }}" ng-class="{ 'has-error': vm.error }" ng-transclude></div>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/form/row/index.js